export const COMPANY_NAME = "REGACIA CURLS LLC";
export const COMPANY_SHORT = "Regacia Curls";
export const COMPANY_INITIALS = "RC";
export const COMPANY_ADDRESS_FULL = "8605 Santa Monica Blvd #225529, West Hollywood, CA 90069";
export const COMPANY_LOCATION = "West Hollywood, CA";
export const COMPANY_REGION = "Los Angeles County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=8605%20Santa%20Monica%20Blvd%20%23225529%2C%20West%20Hollywood%2C%20CA%2090069";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Organic hair products" },
  { "label": "Established", "value": "2025" },
  { "label": "Based in", "value": "West Hollywood, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Regacia Curls LLC" },
  { "label": "Location", "value": "West Hollywood, CA" },
  { "label": "Principal office", "value": "8605 Santa Monica Blvd #225529, West Hollywood, CA 90069" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Curl-focused", "body": "A product-led profile centered on the needs and rituals of textured hair." },
  { "icon": "✦", "title": "Organic focus", "body": "Public business information identifies an emphasis on organic hair products." },
  { "icon": "✿", "title": "Considered essentials", "body": "A concise, approachable presentation for everyday hair-care discovery." },
  { "icon": "❍", "title": "West Hollywood", "body": "A California limited liability company based in West Hollywood." },
];
